var $ = jQuery;

function init() {
  var contactClose = $('.contact-sticky__close');

  if (contactClose.length) {
    contactClose.on('click', function(event) {
      let module = $(this).closest('.contact-sticky');
      event.preventDefault();
      module.css({'animation': 'contact-sticky__hide-animation .5s forwards'}).promise().done(function() {
        module.fadeOut();
      });
    });
  }
}

export { init };
